import type { FC } from 'react';

import { useSession } from '@eneco/auth';
import { DataSet } from '@eneco/components/util/DataSet/DataSet';
import { NavLink, VisuallyHidden } from '@eneco/sparky';
import { ChevronDownIcon, ProfileIcon, SpinnerIcon } from '@eneco/sparky/icons';
import { useI18nTranslation } from '@eneco/sparky/providers';
import { SensitiveContentComponent } from '@eneco/tracking';

import LoginMenu from './LoginMenu';


interface Props {
  onOpen: () => void;
  displayName: string | number | undefined;
  isLoading: boolean;
}

export const ProfileMenuLink: FC<Props> = ({ onOpen, displayName, isLoading }) => {
  const { data: session, status } = useSession() ?? {};

  const openProfileMenu = useI18nTranslation('openProfileMenu');

  if (isLoading || status === 'loading') return <SpinnerIcon />;

  if (!session) return <LoginMenu />;

  return (
    <DataSet label={openProfileMenu}>
      <NavLink onClick={onOpen} leftIcon={<ProfileIcon />} rightIcon={<ChevronDownIcon />}>
        <VisuallyHidden>{openProfileMenu}</VisuallyHidden>
        <SensitiveContentComponent contentMask="masked display name">{displayName}</SensitiveContentComponent>
      </NavLink>
    </DataSet>
  );
};
